<template>
  <div>
    <div v-if="articleList.length > 0">
      <ul>
        <li v-for="(item,index) in articleList" :key="index">
          <h3 class="title">{{ item.title }}</h3>
          <div class="image_box">
            <img :src="item.image[0]">
          </div>
          <p>{{ item.date }}<span>{{ item.columnName }}</span></p>
          <div class="bottom_box">
            {{ item.labelNames }}
            <span @click="jumpArticleDetail(item)"><img src="../assets/imgs/read@2x.png">原文</span>
          </div>
        </li>
      </ul>
      <el-pagination align='right' @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total" style="margin-top:10px">
      </el-pagination>
    </div>
    <div class="none_page" v-else>
      <img src="../assets/imgs/none.png">
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost } from "../assets/http";
import { mapGetters } from "vuex";
// import { devServer } from "../../vue.config.js";
// const baseUrl = devServer.proxy["/dev-api"].target + "/dev-api";
const baseUrl = "/dev-api";
export default {
  props: ["searchValue", "searchType"],
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 11, // 总条数
      pageSize: 9, // 每页的数据条数
      articleList: [],
      baseUrl,
    };
  },
  // this.useData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
  computed: {
    ...mapGetters(["showStyle", "columnId", "labelIds"]),
  },
  watch: {
    // showStyle(newData, oldData) {
    //   console.log(newData, oldData, "showStyle");
    //   // console.log(this.$store.state.showStyle);
    //   // this.getArticleList();
    // },
    columnId(newData, oldData) {
      console.log(newData, oldData, "columnId");
      this.oldColumnId = oldData;
      // console.log(this.labelIds,'columns')
      // this.getArticleList();
      // console.log(this.$store.state.columnId);
    },
    labelIds(newData, oldData) {
      if (
        this.columnId != this.oldColumnId ||
        oldData.length > 0 ||
        newData.length > 0
      ) {
        this.getArticleList();
      }
    },
  },
  created() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      console.log("aboutabout");
      console.log(this.labelIds);
      apiGet("/business/web/getSysConfig", { key: "sys.panel.count" }).then(
        (val) => {
          this.pageSize = Number(val.data.value);
          apiPost("/business/web/getArticleList", {
            columnId: this.columnId,
            labelIds: this.labelIds ? this.labelIds : [],
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            key: this.labelIds ? "" : this.searchValue,
            type: this.labelIds ? "" : this.searchType,
          }).then((res) => {
            // res.rows.forEach((item) => {
            //   let str = "";
            //   item.labelNames.forEach((item1, index) => {
            //     if (index == item.labelNames.length - 1) {
            //       str += item1;
            //     } else {
            //       str += item1 + " | ";
            //     }
            //   });
            //   item.labelNames = str;
            // });
            // res.rows.forEach((item) => {
            // if (item.image) {
            //   if (
            //     item.image[0].indexOf("http") == -1 ||
            //     item.image[0].indexOf("https") == -1
            //   ) {
            //     item.image[0] = baseUrl + item.image[0];
            //   }
          // }
            // });
            // this.articleList = res.rows;
            // this.total = res.total;
            // console.log(this.articleList, "about");
            // loading.close();
          });
        }
      );
    },

    //每页条数改变时触发 选择一页显示多少行
    // handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);
    //   this.currentPage = 1;
    //   this.pageSize = val;
    //   this.getArticleList();
    // },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getArticleList();
    },
    jumpArticleDetail(item) {
      if (item.link != null) {
        window.open(item.link, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/article",
          name: "article",
          query: { articleId: item.articleId },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
  font-family: 思源黑体 Normal;
  font-weight: bold;
  color: #333333;
  padding: 20px;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
ul {
  display: flex;
  flex-wrap: wrap;

  li {
    width: calc((100% - 36px) / 3);
    background: #fff;
    margin-right: 18px;
    margin-top: 18px;
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid transparent;

    .image_box {
      padding: 0 20px;
      width: 100%;
      height: 180px;
      display: flex;
      justify-content: center;
      align-content: center;
      cursor: pointer;
      img {
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
        // height: 100%;
      }
    }
    p {
      padding: 0 20px;
      width: 100%;
      font-size: 12px;
      font-family: 思源黑体 Normal;
      color: #999999;
      margin: 10px 0;
      cursor: pointer;
      span {
        float: right;
      }
    }
    .bottom_box {
      width: 100%;
      padding: 0 20px;
      height: 40px;
      font-size: 12px;
      font-family: 思源黑体 Normal;
      color: #333333;
      border-top: 1px solid #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      span {
        width: 60px;
        height: 24px;
        background: #4190f6;
        font-size: 12px;
        font-family: 思源黑体 Normal;
        color: #ffffff;
        line-height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 12px;
          height: 12px;
          margin-right: 6px;
        }
      }
    }
  }
  li:nth-child(3n) {
    margin-right: 0;
  }
  li:nth-child(-n + 3) {
    margin-top: 0;
  }
  li:hover {
    border: 1px solid #4190f6;
  }
}
</style>
